import styled from 'styled-components';
import { StyledIndicatorsContainerProps } from './types';

export const StyledSelectIndicatorsContainerArrow = styled.span<StyledIndicatorsContainerProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: var(--muted);
  flex-shrink: 0;
  transition: 250ms ease-in-out;
  transform: rotate(
    ${({ menuIsOpen, withoutIndicatorRotation }) =>
      menuIsOpen && !withoutIndicatorRotation ? '180deg' : '0deg'}
  );
  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;
